module.exports = __webpack_public_path__ + "static/assets/6450c84eedce3ec5b895a7056eec5697.svg";